exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-side-bar {\n  background: #fff;\n  z-index: 2; }\n\napp-map-refining {\n  height: 100%; }\n\n.main-content {\n  position: relative;\n  padding-top: 128px; }\n\n.highlight {\n  border: 1px solid red; }\n\n#openseadragon1 {\n  width: 100%;\n  height: 100%; }\n\n.container-fluid {\n  height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main